<div id="why-works" class="my-5 py-5">
  <div class="container mx-auto text-center px-5">
    <div class="flex mb-5 justify-center items-center">
      <img width="50px" src="Icons/icon-start.png" alt="" />
    </div>
    <h3 class="capitalize mb-[3rem] font-bold text-2xl text-center xl:text-5xl lg:text-4xl md:text-3xl">
      Get started - for free
    </h3>
    <div class="md:flex flex-wrap justify-center items-center">
      @for (level of freeLevels(); track $index) {
        <div class="w-full xl:w-1/4 md:w-1/2 mb-5 md:mb-5 px-4">
          @if (loading() || isLoading()) {
            <p-skeleton height="2.5rem" />
          } @else {
            <app-level-item [level]="level" />
          }
        </div>
      }

      @if (levels()?.length ! > 4) {
       <div class="mt-10">
        <app-main-btn
        [routerLink]="['/curriculum']"
        [borderColor]="'primary'"
        [btnTxColor]="'white'"
        [btnColor]="'primary'"
        [btnName]="'View More'" />
       </div>
      }
    </div>
  </div>
</div>
